exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required{\n  color: red;\n}\n.example-full-width{\n  width:100%;   \n}\n.modal-width{\n  width:40%;   \n}\n.modal-body {\n  padding: 10px 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/login-client/login-client.component.css
// module id = ../../../../../src/app/mnt-master/login-client/login-client.component.css
// module chunks = main